import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IFullOfferCategory } from "@/data/model/OfferCategory";
import { Format } from "@/data/util/Format";



import { i18n } from "@/portal/Trans";
import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { OfferCategoryForm } from "@/portal/forms/OfferCategoryForm";
import { TastierGlobal } from "@/portal/globalAccess";
import { UiNotification } from "@/portal/ui/Notification";


export class OfferCategoryController extends BaseTabbedController<IFullOfferCategory> {
    private categoryForm: OfferCategoryForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).offerCategoryDataSource);

        this.categoryForm = new OfferCategoryForm(this.formContentByTabName("categoryedit"));
        this.registerModelForm(this.categoryForm);
    }

    protected onModelLoaded(m?: IFullOfferCategory) {
        if (this.copyEntityId != null) {
            UiNotification.showSuccess(i18n("offerCategory.offerCategoryCopiedAndEditingNow"));
        }
        
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.categoryForm.setData(m, this.copyEntityId);
    }
}
